export interface JwtResponse {
  jwt: string;
}
